<template>
  <div>
     <div v-if="cellData.entries">
       <div v-for="(entry, index) in cellData.entries" :index="index" :key="entry">
        {{ getResult(entry) }}
      </div>
    </div>
    <div v-if="cellData && cellData.SurveyWave && !cellData.entries" class="rescell">
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[1]" class="rescellaw">
         {{ getResult(cellData.SurveyWave[1]) }}
      </div>
      <div  v-else-if="cellData.SurveyWave.length === 1 && cellData.SurveyWave[0]" class="rescelllw" >
        {{ getResult(cellData.SurveyWave[0]) }}
      </div>
      <div  v-else style="width: 0%; height: 1rem;" />
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[0]" class="rescelllw" >
        {{ getResult(cellData.SurveyWave[0]) }}
      </div>
      <div  v-else class="rescellnow" />
    </div>
  </div>
</template>
<script>

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getResult(item) {
      return item.Result ? item.Result + '%' : 'N/A';
    }
  }
};
</script>
<style scoped>

.rescell{
  width: 100%;
  height: 2rem;
}
.rescelllw, .rescellaw, .rescellnow {
  height: 1rem;
}

.rescellnow {
  width: 0%;
}

</style>
